<template>
    <v-row
      id="viewer-pad"
      no-gutters
      justify="center"
      class="viewer-pad"
      :class="{'viewer-pad__mobile': $vuetify.display.smAndDown}"
    >
        <v-col cols="12" md="auto">
            <viewer-pad-button button-type="reset" class="mx-1" @buttonClicked="$emit('resetClick')" />
        </v-col>
        <v-col cols="12" md="auto">
            <viewer-pad-button button-type="dimensions" class="mx-1" @buttonClicked="$emit('dimensionsClick')" />
        </v-col>
        <v-col cols="12" md="auto">
            <viewer-pad-button button-type="screenshot" class="mx-1" @buttonClicked="$emit('screenshotClick')" />
        </v-col>
    </v-row>
</template>
<script>
    import ViewerPadButton from './ViewerPadButton.vue'
    export default {
        name: 'ViewerPad',
        components: {
            ViewerPadButton
        },
        emits: ['resetClick', 'dimensionsClick', 'screenshotClick']
    }
</script>
<style scoped>
    .viewer-pad {
        position: absolute;
        right: 0;
        bottom: 11vh;
        flex-direction: row;
    }

.viewer-pad__mobile {
    bottom: 8vh;
    right: 10px;
    flex-direction: column;
}
</style>